import { Injectable } from '@angular/core';
import { AppService, CoreProxyService, CoreTypes } from 'common-cloudstudio';
import { GearAppService, GearProxyService, GearTypes } from 'common-gear';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DashboardWidgetsEditService {
  _endpointsFullList: BehaviorSubject<CoreTypes.SimpleEndpoint[]> = new BehaviorSubject([]);
  _endpointsStatus = 0;

  _variablesFullList: BehaviorSubject<CoreTypes.VariablesTypeData[]> = new BehaviorSubject([]);
	_variablesStatus = 0;

  _variablesClientsFullList: BehaviorSubject<CoreTypes.VariablesTypeData[]> = new BehaviorSubject([]);
	_variablesClientsStatus = 0;

  _facilitiesFullList: BehaviorSubject<any> = new BehaviorSubject([]);
/*   _facilitiesFullList: BehaviorSubject<GearTypes.GearFacility[]> = new BehaviorSubject([]); */
  _facilitiesIndexedList: number[] = [];
  _facilitiesStatus = 0;

  _dashboardFullList: BehaviorSubject<CoreTypes.Dashboard[]> = new BehaviorSubject([]);
	_dashboardStatus = 0;
  _facilityID: number = this._appService.getFacilityID();


  constructor(
    private _gearProxyService: GearProxyService,
    private _gearAppService: GearAppService,
		private _appService: AppService,
    public _coreProxyService: CoreProxyService
  ) {
    this._appService.onFacilitySet.subscribe(() => {
      this._dashboardFullList.value.length = 0;
      this._facilitiesFullList.value.length = 0;
      this._endpointsFullList.value.length = 0;
      this._variablesFullList.value.length = 0;
      this._variablesClientsFullList.value.length = 0;
      this._dashboardStatus = 0;
      this._endpointsStatus = 0;
      this._facilitiesStatus = 0;
      this._variablesStatus = 0;
      this._variablesClientsStatus = 0;

    })
   }


   getEndpointList(): Promise<CoreTypes.SimpleEndpoint[]> {
		return new Promise((resolve, reject) => {
			if (this._endpointsFullList.value.length || this._endpointsStatus === 1) {
				return resolve(this._endpointsFullList.value);
			}
			this._endpointsStatus = 1;
      this._coreProxyService.DeviceService.EnumSimpleEndpointsForClient(
        this._appService.getAccessToken(),
        this._appService.getClientID(),
        async data => {
          await this.getFacilitiesList();
          this._endpointsFullList.next(data);
          resolve(data);
        },
        error => {
          this._appService.showException(error);
          reject(error);
        }
      )
    })
  }

  getVariableTypesList(): Promise<CoreTypes.VariablesTypeData[]> {
		return new Promise((resolve, reject) => {
			if (this._variablesFullList.value.length || this._variablesStatus === 1) {
				return resolve(this._variablesFullList.value);
			}
			this._variablesStatus = 1;
      this._gearProxyService.MasterEntityService.EnumVariableTypes(
        this._appService.getAccessToken(),
        this._appService.getClientID(),
        this._appService.getFacilityID(),
        0,
        data => {
          this._variablesFullList.next(data);
          resolve(data);
        },
        error => {
          this._appService.showException(error);
          reject(error);
        }
      )
    });
  }

  getClientVariableTypes(): Promise<CoreTypes.VariablesTypeData[]> {
    return new Promise((resolve, reject) => {
			if (this._variablesClientsFullList.value.length || this._variablesClientsStatus === 1) {
				return resolve(this._variablesClientsFullList.value);
			}
			this._variablesClientsStatus = 1;
      this._gearProxyService.MasterEntityService.EnumClientVariableTypes(
        this._appService.getAccessToken(),
        this._appService.getClientID(),
        data => {
          this._variablesClientsFullList.next(data);
          resolve(data);
        },
        error => {
          this._appService.showException(error);
          reject(error);
        }
      )
    });
  }

/*   getFacilitiesList(): Promise<GearTypes.GearFacility[]> { */
  getFacilitiesList(): Promise<any> {
    return new Promise((resolve, reject) => {
      if (this._facilitiesFullList.value.length || this._facilitiesStatus === 1) {
				return resolve(this._facilitiesFullList.value);
			}
      this._facilitiesStatus = 1
      this._coreProxyService.FacilityService.EnumFacilities(
        this._appService.getAccessToken(),
        this._appService.getClientID(),
        data => {
          data.forEach((facility, index) => {
            this._facilitiesIndexedList[facility.FacilityID] = index;
          });
          this._facilitiesFullList.next(data);
          resolve(data);
        },
        error => {
          this._appService.showException(error);
          reject(error);
        }
      )
    });
  }

  getDashboardList(): Promise<CoreTypes.Dashboard[]> {
    return new Promise((resolve, reject) => {
      if (this._dashboardFullList.value.length || this._dashboardStatus === 1) {
				return resolve(this._dashboardFullList.value);
			}
      this._dashboardStatus = 1;
      this._coreProxyService.DashboardService.EnumClientDashboards(
        this._appService.getAccessToken(),
        this._appService.getClientID(),
        true,
        data => {
          this._dashboardFullList.next(data);
          resolve(data);
        },
        error => {
          this._appService.showException(error);
          reject(error);
        }
      )
    });
  }

  appliesToTimeRange(item: CoreTypes.VariablesTypeData): boolean {
    if (
      item.VariableTypeID === CoreTypes.EndpointVariableType.RunTime ||
      item.VariableTypeID === CoreTypes.EndpointVariableType.Flow ||
      item.VariableTypeID === CoreTypes.EndpointVariableType.ActiveEnergy ||
      item.VariableTypeID === CoreTypes.EndpointVariableType.PeopleFlow ||
      (item.IsCustom && item.VariableSubtype === CoreTypes.EndpointVariableSubtype.Flow)
    ) { return true; }

    return false;
  }
  
  validateMinMax(event) {
    var regex = new RegExp("^[0-9-.]+$");
    var str = event.clipboardData.getData('text');
    if (regex.test(str)) { return true; }
    event.preventDefault();
    return false;
  }

}
